import { useEffect } from "react";
import { tariffsStore } from "@src/entities/tariffs/model/store/tariffsStore";
import { TariffSection } from "@src/widgets/TariffSection";
import { useGetTariffs } from "@src/entities/tariffs/model/hooks/useGetTariffs/useGetTariffs";
import { WrapperLoading } from "@src/shared/components/WrapperLoading/WrapperLoading";

import styles from "./SelectTariff.module.scss";

export function SelectTariff() {
  const { data, isSuccess, isFetching, isError } = useGetTariffs();
  const setTariffs = tariffsStore((state) => state.setTariffs);

  useEffect(() => {
    if (isSuccess) {
      setTariffs(data.data);
    }
  }, [isSuccess]);

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>Выбрать тариф</h1>
      <div className={styles.content}>
        <WrapperLoading isLoading={isFetching && !isSuccess} isError={isError}>
          <TariffSection />
        </WrapperLoading>
      </div>
    </div>
  );
}
